import { useGetClientMetaListResponse } from '@/apis/rest/generated/hooks'
import { GetClientMetaListResponseParams, PlatformTypeParamParameter } from '@/apis/rest/generated/types'
import { PaymentMethodTypeEnum } from '@/constants/payment-method-type.enum'
import { MetaClientCategoryType } from '@/types/meta-client-category.type'
import { PaymentMethodBenefitContents } from '@/types/payment-method-benefit.type'

const usePaymentMethodBenefits = () => {
  try {
    const params: GetClientMetaListResponseParams = {
      platformType: PlatformTypeParamParameter.WEB,
      category: MetaClientCategoryType.paymentMethodBenefit,
    }
    const { data } = useGetClientMetaListResponse(params, {
      query: {
        select: (result) =>
          result?.map((item) => ({
            method: item.key as PaymentMethodTypeEnum,
            contents: JSON.parse(item.value['contents'] || '[]') as PaymentMethodBenefitContents[],
          })),
      },
    })
    return { paymentMethodBenefits: data }
  } catch (error) {
    console.error(error)
    return { paymentMethodBenefits: [] }
  }
}

export { usePaymentMethodBenefits }
